import React from 'react'
import { TradingAccountCountryDto } from 'api/Trading-Accounts/Types/TradingAccountCountryDto'
import { UpdateTradingAccountCountry } from 'api/Trading-Accounts/Types/UpdateTradingAccountCountry'

import { EditTradingAccountCountryForm } from './EditTradingAccountCountryForm'

interface Props {
  data: TradingAccountCountryDto

  onSubmit(values: UpdateTradingAccountCountry): void
}

const EditTradingAccountCountryPage: React.FC<Props> = ({ data, onSubmit }) => {
  return <EditTradingAccountCountryForm data={data} onSubmit={onSubmit} />
}
export default EditTradingAccountCountryPage
